import React, {Fragment} from 'react';
import {
    Card,
    Table,
    Menu,
    Dropdown,
    Space,
    Input,
    Row,
    Button,
    Typography,
    Modal,
    Form,
    Select,
    Checkbox,
    TimePicker,
    InputNumber,
    notification,
    Spin, Steps, Divider, DatePicker, Switch
} from "antd";

import {
    DownOutlined,
    DownloadOutlined,
    DeleteOutlined,
    PlusOutlined,
    EuroCircleOutlined,
    LinkOutlined,
    MinusOutlined
} from '@ant-design/icons';

import ApiService from "../../../services/ApiService"

import moment from 'moment'
import PermissionAlert from "../../../components/permissions/PermissionAlert";

import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";

const {Search} = Input;
const {Text} = Typography;
const {Option} = Select;


export default class ModalChangeContact extends React.Component {

    constructor(props) {
        super(props);
        props.getRef(this)
    }

    initstate = {
        visible: false,
        loading: false,
        info: null,
        contacts: [],
        contact: null,
        id: null
    };

    state = this.initstate

    async show(id, contact) {
        console.log("PAYEMENT CHANGE CONTACT ", contact)

        this.setState({visible: true, id: id, contact: contact})

        await this.getContacts()
    }

    async getContacts() {
        var res = await ApiService.get("/contact/form")
        this.setState({contacts: res.data})
    }

    close() {
        this.setState(this.initstate)
    }

    async onFinish(data) {
        console.log(data)

        var res = await ApiService.post("/paiements/change/contact/" + this.state.id, {contact: data.contact})
        console.log(res)

        if (res.success) {
            notification.success({
                message: t`Modification réussie`
            })

            this.close()
            if (this.props.onFinish) {
                this.props.onFinish()
            }
        } else {
            notification.error({
                message: t`Erreur lors de la modification`
            })
        }
    }


    render() {
        return (
            <Fragment>
                <Modal
                    width={"100%"}
                    style={{minHeight: 500}}
                    title={t`Changer le contact`}
                    open={this.state.visible}
                    destroyOnClose
                    closable
                    footer={null}
                    onCancel={() => this.close()}
                >
                    <PermissionAlert permissions={["paiement.edit"]}>
                        <Form
                            initialValues={{
                                contact: this.state.contact
                            }}
                            onFinish={(data) => this.onFinish(data)}
                        >
                            <div style={{marginBottom: 20}}>
                                <Form.Item
                                    label={t`Choisir un contact`}
                                    name="contact"
                                >
                                    <Select
                                        style={{width: 300, maxWidth: "100%", marginRight: 5, marginBottom: 5}}
                                        placeholder={t`Choisir un contact`}
                                        showSearch
                                        filterOption={(input, option) => {
                                            var text = option.props.children
                                            if (Array.isArray(text)) {
                                                text = text.join("")
                                            }
                                            return text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }}
                                    >
                                        {this.state.contacts.map((item, index) => {
                                            var telValue = ""
                                            if (item.tel) {
                                                telValue = "(" + item.tel + ")"
                                            }

                                            var emailValue = ""
                                            if (item.email) {
                                                emailValue = "(" + item.email + ")"
                                            }

                                            return (
                                                <Select.Option key={index} value={item.id}>
                                                    {item.prenom} {item.nom} {telValue} {emailValue}
                                                </Select.Option>
                                            )
                                        })}
                                    </Select>
                                </Form.Item>
                            </div>

                            <Form.Item style={{display: "flex", justifyContent: "flex-end"}}>
                                <Button type="primary" htmlType="submit" loading={this.state.loading}>
                                    <Trans>Valider</Trans>
                                </Button>
                            </Form.Item>
                        </Form>
                    </PermissionAlert>
                </Modal>
            </Fragment>
        )
    }
}
